import React from "react";
import tw from "twin.macro";
import { Link } from "gatsby";

import { AiFillLock } from "react-icons/ai";
import { BsFillLockFill } from "react-icons/bs";
import { IoIosLock } from "react-icons/io";

const Wrapper = tw.div`flex flex-row items-center gap-4`;

const FormDisclaimer = ({ ...rest }) => {
  return (
    <Wrapper {...rest}>
      <IoIosLock tw="text-primary text-3xl" />
      <p tw="font-bold text-sm leading-none">
        100% Secure. We respect your privacy.{" "}
        <Link
          tw="whitespace-nowrap text-primary hover:underline"
          to="/privacy-policy/"
        >
          See here.
        </Link>
      </p>
    </Wrapper>
  );
};

export default FormDisclaimer;
